'use strict';

import ajax from '../../ajax';
import progress from '../../progress';
import tooltip from '../../tooltip';
import util from '../../util';
import validator from '../../validator';
import modalExport from '../../modal';
const modal = modalExport.global;
import checkoutAddress from './address';
import googleAddressAutocomplete from './googleAddressAutocomplete';
import inputField from '../../input-field';
import royalMail from "../../royal-mail";
import mondialRelay from "../../mondial-relay";
import billingRedesign from './billing';
import analytics from '../../analytics';
import reinsurancePanel from '../reinsurancePanel';
import cart from "../cart";
import chronopostPickup from "../../chronopost_pickup";
import { singleShippingDesign } from './billing';

var $cache, shippingMethods;

function initCache() {
    var $formEle = $('form[id$="_shippingAddress"]');

    if($formEle.find('input[name$="isRedesign"]').length && $formEle.find('input[name$="isRedesign"]').val()){
        var countryCode = $formEle.find('select[id$="_country"]');
        if(countryCode.length > 1){ 
            countryCode = $formEle.find('select[id$="_shippingAddress_addressFields_country"]');
        } else if(countryCode.length <= 1){
            countryCode = $formEle.find('input[id$="_country"]');
        } 
        
    }else{
        var countryCode = $formEle.find('select[id$="_country"]');
        if(countryCode.length == 0){
            countryCode = $formEle.find('input[id$="_country"]');
        }
    }

    $cache = {
        addrForm: {
            address1: $formEle.find('input[name$="_address1"]'),
            address2: $formEle.find('input[name$="_address2"]'),
            countryCode: countryCode,
            stateCode: $formEle.find('select[id$="_state"]'),
            postalCode: $formEle.find('input[name$="_postal"]'),
            city: $formEle.find('input[name$="_city"]')
        }
    };
}

//This function will be updated later as reusable component
function updatePlaceholderCountryChange() {

	$('select[id$="_country"]').on('selectmenuchange change',function(){
		const countryValue = $(this).val();
		if (!countryValue) {
			return;
		}
		const optionFlagValue = $('.input-select.country').find('.flag-'+countryValue.toLowerCase());
        const placeholderCity = optionFlagValue.attr('data-placeholder');
        const placeholderPhone = optionFlagValue.attr('data-phone');
        const placeholderPostal = optionFlagValue.attr('data-postal');

		//update city placeholder value with the changed country
		const nearestFieldSet = $(this).closest('fieldset');
		nearestFieldSet.find('.input-text.city').attr('placeholder', placeholderCity);
		nearestFieldSet.find('.input-text.phonenumber').attr('placeholder', placeholderPhone);
		nearestFieldSet.find('.input-text.postal').attr('placeholder', placeholderPostal);
	});
    $('select[id$="_country"]').trigger('change');

	//For BE,DE and ROE markets, the placeholder should be empty if no country is selected from dropdown
	$(document).ready(function () {
		if($('.country').hasClass('input-select')) {
			const countryVal = $('.input-select.country').val();
			const nearestFieldSet = $('.input-select.country').closest('fieldset');
			if(!countryVal) {
				nearestFieldSet.find('.input-text.city').attr('placeholder', '');
				nearestFieldSet.find('.input-text.phonenumber').attr('placeholder', '');
				nearestFieldSet.find('.input-text.postal').attr('placeholder', '');
			}
		}
	});
}
function reinsuranceCart() {
	$(document).on('click', '.reinsurance-wrapper-cart', function (e) {
        e.stopImmediatePropagation();
        if($(this).parent().hasClass("open-reinsurance-panel")) {
            $(this).prop("disabled", false);
			var contentAssetId = $(this).parent().attr("data-content-id");
			reinsurancePanel.openReinsurancePanel(contentAssetId);
        } else {
            if($(this).hasClass('desktop-only')) {
                $(this).toggleClass('show-description')
                $(this).siblings().toggleClass('hidden');
                $(this).parents('.content-asset').toggleClass('flex-ease');
                $('.reinsurance-wrapper-cart').not(this).removeClass('show-description');
            } else {
                $(this).toggleClass('show-description')
                $(this).siblings().toggleClass('hidden');
                $(this).parents('.content-asset').toggleClass('flex-ease');
                $(this).parents('.reinsurance-checkout-mobile .content-asset').siblings().toggleClass('hide');
                $('.reinsurance-wrapper-cart').not(this).removeClass('show-description');
            } 
        }
	});
	
	$(document).ready(function() { 
        setTimeout(function() {
            $("#applepay-container button").attr("aria-label", Resources.APPLE_PAY_LABEL);
            $("div.applepay-button").removeAttr("aria-label");
        }, 1000);

        $('.reinsurance-wrapper-cart.mobile-only').parents('.content-asset').addClass('flex-ease');
        $('.reinsurance-wrapper-cart').each(function() {
            if($(this).parent().hasClass("open-reinsurance-panel")) {
                setTimeout(function(){
                    var element = $('.reinsurance-element.open-reinsurance-panel');
                    element.prop("disabled", false);
                }, 500);
            } else {
                if ($(this).find('.reinsuranceDesc').length === 0) {
                    $(this).addClass('remove-plus-icon');
                    $(this).prop("disabled", true);
                }
            }
        });
    });
    
	$(document).on('click', '.reinsurance-checkout-mobile .mobile-only', function (e) {
        e.stopImmediatePropagation();
		if(!$(this).parent().hasClass("open-reinsurance-panel")) {
			if ($(this).find('.reinsuranceDesc').length === 0){
				$(this).on('click', function(event) {
					event.preventDefault();
				});
			} else {
				$('.reinsurance-checkout-mobile .mobile-only').not(this).toggleClass('hidden');
			}
		}
	});
}

function initEvents() {
    setTimeout(() => {
        reinsuranceCart();
    }, 1000);
    $(document)
        // create address link
        .on("click", ".select-shipping-address .address-create", function (evt) {
            modal.addCustomClass('edit-add-address new-add-address');
            modal.events.onOpen(function() {
                validator.initForm('form[id="EditAddressForm"]');
                validator.changeFieldValidation();
                if($('select[id$="_country"]').length > 0){
                   $('#dwfrm_shippingaddress__emea_country').val("");
                }
                // to initialize country code only when input[type=text] field rendered
                if($('input[id$="__emea_country"]').length) {
                    prePopulateCallingCountryCode($('#dwfrm_shippingaddress__emea_country').val());
                }    
                tooltip.init();
                checkoutAddress.init();
                googleAddressAutocomplete.init();
                updatePlaceholderCountryChange();
                if($('.input-text.valid').length<=7 || $('.input-text.error').length>=0) {
                    $('button[type="submit"').prop('disabled',true);
                }
                $('html').addClass('modal-open');
            });
            modal.renderByUrl(Urls.checkoutAddAddress);
            util.phoneShippingAddressModal();
            util.postalShippingAddressModal();
            setTimeout(() => {
                $('.address1').attr('autocomplete', 'on'); // Avoid to autocomplete address 1
				util.limitCharacters();
                if($('#EditAddressForm').find('.lastname2').length >= 1 || $('#EditAddressForm').find('.placecountry-editaddress').length >= 1) {
                    $('fieldset.form-details').scrollBox();
                } 
			}, 2500);
            modal.events.onClose(function() {
                $('html').removeClass('modal-open');
            });
        })

        // edit address link
        .on("click", ".address-edit", function (evt) {
            evt.stopPropagation();
            var $this = $(this);
            var addressID = $this.data('addressId');
            getValidPostalCity(addressID,true,false);
            setTimeout(() => {
                $('.address1').attr('autocomplete', 'on'); // Avoid to autocomplete address 1
                util.limitCharacters();
                updatePlaceholderCountryChange();
				validator.changeFieldValidation();
                if($('#EditAddressForm').find('.lastname2').length >= 1 || $('#EditAddressForm').find('.placecountry-editaddress').length >= 1) {
                    $('fieldset.form-details').scrollBox();
                }
            }, 2500);
            
        })

        // authenticated user address change
        .on('click', '.shipping-address-section .address-list .address-tile', function (evt) {
            if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
                return false;
            }

            $('.address-list .address-tile').each(function() {
                $(this).removeClass('selected');
                $(this).removeClass('default');
            });

            $(this).addClass('selected');

            var element = document.getElementById(evt.currentTarget.id);
            var addressID = element.dataset.addressId;

            // update address; on success update shipping method list
            $.get(Urls.updateAddressDetails, { addressID: addressID }, function (response) {                
                getValidPostalCity(addressID,false,true);
            });

            checkSelectedAddress();
        });

        

    // guest user address change
    var timer = null;
    $('form[id$="_shippingAddress"]').on('selectmenuchange change', 'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], select[name$="_addressFields_country"], input[name$="_addressFields_city"], input[name$="_addressFields_postal"]', function () {
    	var $formEle = $('form[id$="_shippingAddress"]');
        var countryCode = $cache.addrForm.countryCode;
        if(countryCode.val() == null || countryCode.length == 0){
            countryCode = $cache.addrForm.countryCode;
        }

        if (!countryCode || (countryCode.val() === "") ) {
        	$('#shipping-method-list').empty();
        } else {
            $cache.addrForm.countryCode = countryCode;
        }
    	
    	
    	if (!validateAddrForm()) {
            return;
        }

        if (timer) {
            window.clearTimeout(timer);
        }

        if($('.sameasbilling').is(':checked')){
            $('#dwfrm_billing_billingAddress_addressFields_country').val($cache.addrForm.countryCode.val());
        }
        timer = window.setTimeout(function () {
            $.post(Urls.setShippingAddressDetails, $('form[id$="_singleshipping_shippingAddress"]').serialize(), function (result) {
                updateShippingMethodList();
            });
        }, 50);
    });

    $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);
    $('input[name$="_cart_isGift"]').on('click', giftMessageBox);
    $('.new-add-address').find('#EditAddressForm').on('blur', 'input[name$="_firstName"], input[name$="_lastName"], input[name$="_address1"], input[name$="_address2"], select[name$="_country"], input[name$="_city"], input[name$="_postal"], input[name$="_phoneNumber"]', function() {	
		var validateErrorTimer = null;
		// to disable submit button when all fields are valid and no-shipping method error is visible
		if($(this).valid()) {
			if(validateErrorTimer) {
				window.clearTimeout(validateErrorTimer);
			}
			validateErrorTimer = window.setTimeout(function() {
				validateAddAdressError();
			}, 100);
		}
	});

    $(document).on('ready', function () {
        $('.sameasbilling').on('change', function () {
            updateSummary();
            $('.billing-address-section').parent().find('input').blur();
        });
        $('.select-option.select-country').remove();

    });

    initCache();

}

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
    $('.complimentary-gift-container').toggleClass('hidden, hide', $('input[name$="_cart_isGift"]:checked').val() !== 'true');
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
    var $summary = $('#secondary.summary');
    var couponError;

    if ($('.cart-coupon-code .error').length) {
        couponError = $('.cart-coupon-code .error').clone();
    }

    // indicate progress
    progress.show($summary);

    var url = Urls.summaryRefreshURL;

    // load the updated summary area
    $summary.load(url, function () {
        // hide edit shipping method link
        $summary.fadeIn('fast');

       // checkout checkout minicart on right side event handling
        addSummaryScrollbar();

        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        $('.cart-coupon-code').append(couponError);
        util.maximizeCheckoutSummary();

        $(".checkout-mini-cart .accordion").foundation();
    });

    inputField.setEditMaterialFields();	
    setTimeout(() => {
        initScrollProductInformation();
    }, 500);
}

function getAddressFromTile() {
    var $selectedAddress = $(".address-tile.selected address");
    return {
        address1: $selectedAddress.data("address-one"),
        address2: $selectedAddress.data("address-two") || "",
        countryCode: $selectedAddress.data("country-code"),
        postalCode: $selectedAddress.data("postal-code"),
        city: $selectedAddress.data("city"),
        isRedesign: $( "body" ).hasClass( "checkout_page" )
    };    
}

function getAddressFromForm() {  
    return {
        address1: $cache.addrForm.address1.val(),
        address2: $cache.addrForm.address2.val(),
        countryCode: $cache.addrForm.countryCode.val(),
        postalCode: $cache.addrForm.postalCode.val(),
        city: $cache.addrForm.city.val(),
        isRedesign: $( "body" ).hasClass( "checkout_page" ) 
    };
}
/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
    var params = User.isCustomerAuthenticated && hasSavedAddress() ? getAddressFromTile() : getAddressFromForm();
    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 *  @description Helper method which return if authenticated customer is having saved addresses or not.
 * @returns
 */
function hasSavedAddress() {
    var $selectedAddress = $(".address-tile.selected address");
    if($selectedAddress.length > 0){
    	return true;
    }else{
    	return false;
    }
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(Urls.selectShippingMethodsList, {shippingMethodID: shippingMethodID});
    ajax.getJson({
        url: url,
        callback: function (data) {
            updateSummary();
            if (!data || !data.shippingMethodID) {
                window.alert('Couldn\'t select shipping method.');
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();


            // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
            //     var len = data.shippingPriceAdjustments.length;
            //     for (var i=0; i < len; i++) {
            //         var spa = data.shippingPriceAdjustments[i];
            //     }
            // }
        }
    });
}

/**
 * @function
 * @description Handle selection of Mondial Relay shipping method
 * @param {jQuery} $element - The selected shipping method element
 */
function handleMondialRelaySelection($element) {
    // Enable other methods
    $(".royal-mail-method, .chronopost-method").removeAttr("disabled");

    // Bind edit button
    $element.parent().find('.store-address-edit').on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        mondialRelay.renderMondialRelayPopup();
    });

    // Activate edit button if store details exist
    if (!$(".store-details-section").is(':empty')) {
        $element.parent(".shipping-method").find(".store-address-edit").addClass("active");
    }

    // Handle confirmation
    $('.store-address-confirm').on("click", function (e) {
        mondialRelay.confirmationMondialRelayPopup();
        mondialRelay.closeMondialRelayPopup();
        var selectedStoreData = localStorage.getItem("selectedStoreData");
        if (selectedStoreData) {
            selectedStoreData = JSON.parse(selectedStoreData);
            var address = selectedStoreData.Adresse1;
            if (selectedStoreData.Adresse2) {
                address += ' ' + selectedStoreData.Adresse2;
            }
            $('#selectedStoreName').html(selectedStoreData.Nom);
            $('#pickupStore_storeAddress1').val(selectedStoreData.Nom);
            $('#pickupStore_storeAddress2').val(address);
            $('#pickupStore_storeAddressPostal').val(selectedStoreData.CP);
            $('#pickupStore_storeAddressCity').val(selectedStoreData.Ville);
            $('#pickupStore_storeAddressCountry').val(selectedStoreData.Pays);
            $('input[id$="_setdefault"]').prop('checked', true).attr('disabled', 'true');
            var mondialAddress = `<span class='address-line1'>${selectedStoreData.Adresse1}</span><br/><span class='address-line2'>${selectedStoreData.Adresse2}</span><span class='postcode'>${selectedStoreData.CP}</span> - <span class='city'>${selectedStoreData.Ville}</span> <span class='country'>${selectedStoreData.Pays}</span>`;
            $('.store-details-section').html(mondialAddress).addClass('filled');
            if (!$('.store-details-section').is(':empty')) {
                $(".store-address-edit").addClass("edit-btn-active");
                $('.store-address-edit, .address-pin-icon, .store-details-wrapper').removeClass('hide');
            }
        }
        $('#pickupStore_storeID').val($('#Target_Widget').val());
    });

    // Handle popup close
    $('.mrelay-wrapper .mrelay-overlay, .mrelay-close').on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        mondialRelay.closeMondialRelayPopup();
        validateMondialRelayAddress();
    });

    // Disable if already active, otherwise render popup
    if ($element.parent().find(".store-address-edit").hasClass("edit-btn-active")) {
        let selectedStoreData = localStorage.getItem("selectedStoreData");
        if (selectedStoreData) {
            selectedStoreData = JSON.parse(selectedStoreData);
            let address = selectedStoreData.Adresse1;
            if (selectedStoreData.Adresse2) {
                address += ' ' + selectedStoreData.Adresse2;
            }
            $('#selectedStoreName').html(selectedStoreData.Nom);
            $('#pickupStore_storeAddress1').val(selectedStoreData.Nom);
            $('#pickupStore_storeAddress2').val(address);
            $('#pickupStore_storeAddressPostal').val(selectedStoreData.CP);
            $('#pickupStore_storeAddressCity').val(selectedStoreData.Ville);
            $('#pickupStore_storeAddressCountry').val(selectedStoreData.Pays);
        }
        $('#pickupStore_storeID').val($('#Target_Widget').val());
        $(".mondial-relay-method").prop("disabled", "disabled");
    } else {
        mondialRelay.renderMondialRelayPopup();
    }

    // Clear other data
    localStorage.removeItem('storedAddressData');
    localStorage.removeItem('royalMail-edit_' + $('royal-mail-method').val());
    $('.store-royalMail-details').removeClass('active');
    $('.chronopost-method').parent().removeClass('edit-btn-active');
}

/**
 * @function
 * @description Handle selection of Royal Mail shipping method
 * @param {jQuery} $element - The selected shipping method element
 */
function handleRoyalMailSelection($element) {
    var thisShipping = $element;

    // Activate edit button if details exist
    if (!$(".store-details-royalMail-section").is(':empty')) {
        $element.parent(".shipping-method").find(".store-address-edit").addClass("active");
    }

    // Enable all methods
    $(".mondial-relay-method, .royal-mail-method, .chronopost-method").removeAttr("disabled");

    // Clear or handle mondial data
    if ($element.parent(".shipping-method").hasClass("edit-btn-active")) {
        localStorage.removeItem('selectedStoreData');
        $('.store-details-section').empty();
        $('.shipping-method').removeClass('edit-btn-active');
        royalMail.setPickupStoreValue($element);
    } else {
        $('.store-details-section').empty();
    }

    // Close popup handlers
    function closePopupRoyal(thisShipping) {
        $('.royalMail-wrapper .royalMail-overlay, .royalMail-wrapper .widgfooter').on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            royalMail.closeRoyalMailPopup();
            validateRoyalMailAddress(thisShipping);
        });

        setTimeout(() => {
            $(document).on('click', '.royalMail-close', function (e) {
                e.stopPropagation();
                e.preventDefault();
                royalMail.closeRoyalMailPopup();
                validateRoyalMailAddress(thisShipping);
            });
        }, 1000);
    }

    closePopupRoyal(thisShipping);

    // Select button handler
    $(document).on('click', '.widget-select-button', function (e) {
        e.stopPropagation();
        e.preventDefault();
        thisShipping.prop('checked', 'checked');
        royalMail.closeRoyalMailPopup();
    });

    // Render popup if not active
    if (!$element.parent('.shipping-method').find('.royalMail-wrapper').hasClass('active')) {
        if (thisShipping.parent().find(".store-details-royalMail-section").hasClass("filled")) {
            thisShipping.prop("disabled", "disabled");
        } else {
            $('.royalMail-wrapper').addClass('active');
            $('.royalMail-overlay').show();
            localCollectSelected(royalMail.renderRoyalMail($element));
        }
    }

    // Edit button handler
    var buttonEdit = thisShipping.parent().find('.store-royalMail-details .store-address-edit');
    buttonEdit.on('click', function(e) {
        e.stopPropagation();
        setTimeout(() => {
            localCollectSelected(royalMail.renderRoyalMail(thisShipping));
            $('.royalMail-wrapper').addClass('active');
            $('.royalMail-overlay').show();
        }, 500);
    });
}

/**
 * @function
 * @description Handle selection of Chronopost shipping method
 * @param {jQuery} $element - The selected shipping method element
 */
function handleChronopostSelection($element) {
    const thisShipping = $element;

    // Activate edit button if details exist
    if (!$(".store-details-chronopostpickup-section .postcode").is(':empty') && localStorage.getItem('storedAddressDataChronopost')) {
        $element.parent(".shipping-method").find(".store-address-edit").parents(".shipping-method").addClass("edit-btn-active");
        chronopostPickup.setPickupStoreValue(thisShipping);
    }

    // Enable other methods
    $(".mondial-relay-method, .royal-mail-method").removeAttr("disabled");

    // Handle active state
    if (thisShipping.parent().find(".store-details-chronopostpickup-section").hasClass('filled')) {
        thisShipping.parent(".shipping-method").find(".store-address-edit").parents(".shipping-method").addClass("edit-btn-active");
        // Disable to prevent accidental deselect
        $(".chronopost-method").attr("disabled", "disabled");
    } else {
        // Open modal
        chronopostPickup.init();
    }

    // Edit button handler
    thisShipping.parent().find('.store-address-edit').off('click.chronoEdit').on('click.chronoEdit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $chronopostContainer = $('#chronopost-pickup-container');
        if ($chronopostContainer.find('.modal').length) {
            $('html').addClass('modal-open');
            $chronopostContainer.removeClass('hide');
        } else {
            chronopostPickup.init();
        }
    });
}

/**
 * @function
 * @description Handle selection of default/other shipping methods
 */
function handleDefaultSelection() {
    // Enable all methods
    $(".mondial-relay-method, .royal-mail-method, .chronopost-method").removeAttr("disabled");
}

/**
 * @function
 * @description Initialize shipping methods on page load
 * @param {jQuery} $shippingMethodList - The shipping method list container
 */
function initializeShippingMethodsOnLoad($shippingMethodList) {
    // Select first method if none selected
    if ($shippingMethodList.find('input:checked').length === 0) {
        $shippingMethodList.find('input:first').prop('checked', 'checked');
        var thisShipping = $shippingMethodList.find('.shipping-method-input:checked');

        // Handle Mondial Relay
        if (($(".checkout-shipping .input-text.error").length && localStorage.getItem("storeDetailsSection")) ||
            $("input:radio.shipping-method-input:checked").hasClass('mondial-relay-method')) {
            $(".store-details-section").html(localStorage.getItem("storeDetailsSection"));
            let selectedStoreData = localStorage.getItem("selectedStoreData");
            if (selectedStoreData) {
                selectedStoreData = JSON.parse(selectedStoreData);
                let address = selectedStoreData.Adresse1;
                if (selectedStoreData.Adresse2) {
                    address += ' ' + selectedStoreData.Adresse2;
                }
                $('#pickupStore_storeID').val(selectedStoreData.Pays + "-" + selectedStoreData.ID);
                $('#pickupStore_storeAddress1').val(selectedStoreData.Nom);
                $('#pickupStore_storeAddress2').val(address);
                $('#pickupStore_storeAddressPostal').val(selectedStoreData.CP);
                $('#pickupStore_storeAddressCity').val(selectedStoreData.Ville);
                $('#pickupStore_storeAddressCountry').val(selectedStoreData.Pays);
                $('.store-details-section').addClass('filled');
            }
        }

        var shippingID = $shippingMethodList.find('.shipping-method-input:checked').attr('value');
        var old_storedAddressData = JSON.parse(localStorage.getItem('storedAddressData'));
        if (localStorage.getItem('storedAddressData') != null && old_storedAddressData[shippingID]) {
            royalMail.updateRoyalMailShippingAddress(thisShipping);
            royalMail.setPickupStoreValue(thisShipping);
            $('.store-details-section').empty();
        } else if (!$('.store-details-section').is(':empty')) {
            $('.store-details-section').parent().find('.store-address-edit').parents(".shipping-method").addClass("edit-btn-active");
            $('.store-details-section').addClass('filled');
            royalMail.setPickupStoreValue(thisShipping);
        }
    } else if ($shippingMethodList.find('.input-radio:checked').hasClass('mondial-relay-method') ||
        $("input:radio.shipping-method-input:checked").hasClass('mondial-relay-method')) {

        if ($('.store-details-section').length > 0 && localStorage.getItem("storeDetailsSection")) {
            $(".store-details-section").html(localStorage.getItem("storeDetailsSection"));
            $('.store-address-edit, .address-pin-icon, .store-details-wrapper').removeClass('hide');
            $(".store-address-edit").addClass("edit-btn-active");

            let selectedStoreData = localStorage.getItem("selectedStoreData");
            if (selectedStoreData) {
                selectedStoreData = JSON.parse(selectedStoreData);
                let address = selectedStoreData.Adresse1;
                if (selectedStoreData.Adresse2) {
                    address += ' ' + selectedStoreData.Adresse2;
                }
                $('#pickupStore_storeID').val(selectedStoreData.Pays + "-" + selectedStoreData.ID);
                $('#pickupStore_storeAddress1').val(selectedStoreData.Nom);
                $('#pickupStore_storeAddress2').val(address);
                $('#pickupStore_storeAddressPostal').val(selectedStoreData.CP);
                $('#pickupStore_storeAddressCity').val(selectedStoreData.Ville);
                $('#pickupStore_storeAddressCountry').val(selectedStoreData.Pays);
            }
        }
    } else if ($shippingMethodList.find('input:checked').hasClass('royal-mail-method')) {
        var thisShipping = $shippingMethodList.find('input:checked');
        royalMail.updateRoyalMailShippingAddress(thisShipping);
        thisShipping.parent().find('.store-details-section').empty();
        royalMail.setPickupStoreValue(thisShipping);

        var buttonEdit = thisShipping.parent().find('.store-royalMail-details .store-address-edit');
        buttonEdit.on('click', function (e) {
            e.stopPropagation();
            setTimeout(() => {
                localCollectSelected(royalMail.renderRoyalMail(thisShipping));
                $('.royalMail-wrapper').addClass('active');
                $('.royalMail-overlay').show();
            }, 500);
        });
    } else if ($shippingMethodList.find('input:checked').hasClass('chronopost-method')) {
        chronopostPickup.setPickupStoreValue($shippingMethodList.find('.shipping-method-input:checked'));
        chronopostPickup.updateChronopostShippingAddress($shippingMethodList.find('.shipping-method-input:checked'));
    }

    // Handle Chronopost edit button activation
    if (localStorage.getItem("storedAddressDataChronopost") && !$('.store-details-chronopostpickup-section .postcode').is(':empty')) {
        $(".chronopost-method").parents(".shipping-method").addClass("edit-btn-active");
        $('.store-chronopostpickup-details').find('.address-pin-icon').removeClass('hide');
    }

    // Tooltip handler
    $(".mondial-relay-method").next("label").find(".tooltip").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
    });

    // Widget confirm visibility
    if ($('.PR-List-Item').hasClass('PR-Selected')) {
        $('.zone_widget_confirm').removeClass('hide');
    }
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
	$('input[id$="_setdefault"]').removeAttr('disabled');
    var $shippingMethodList = $('#shipping-method-list');
    var countryCodeVal = '';
    if (!$shippingMethodList || $shippingMethodList.length === 0) { return; }
    
    var $formEle = $('form[id$="_shippingAddress"]');
    var countryCode = $formEle.find('select[id$="shippingAddress_addressFields_country"]');
    if(countryCode.length == 0){
    	countryCode = $formEle.find('input[id$="shippingAddress_addressFields_country"]');
    }
    
    if( (countryCode.length == 0) && $(".address-tile.selected")){ 
       countryCodeVal = $(".address-tile.selected").find("address").data('country-code');
    }

    if ((!countryCode || (countryCode.val() === "") || (countryCode.val() === undefined)) && (countryCodeVal === '')) {
    	return;
    }
   
    var url = getShippingMethodURL(Urls.shippingMethodsJSON);
    ajax.getJson({
        url: url,
        callback: function (data) {
        	var $form = $('form[id$="_shippingAddress"]'),
        		$submit = $form.find('button[type="submit"]');
        	if(data.length === 0){
        		$submit.prop('disabled', true);
        	}else{
        		$submit.prop('disabled', false);
        	}
            if (!data) {
                window.alert('Couldn\'t get list of applicable shipping methods.');
                return false;
            }
            
            

            // shipping methods remain unchanged; update summary as selected method may/may not change
            /*
             * Below code is creating issue when Canada addresses are switching.
             * updateSummany is assigning default shipping method to Canada address irrespective of shipping methods is applicable to Canada addresses or not.
             */
           /* if (shippingMethods && shippingMethods.toString() === data.toString()) {
                updateSummary();
                return true;
            } */

            // We need to update the UI.  The list has changed.
            // Cache the array of returned shipping methods.
            shippingMethods = data;
            // indicate progress
            progress.show($shippingMethodList);
            
            // load the shipping method form
            var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
            if($("input:radio.shipping-method-input:checked").hasClass('mondial-relay-method') && !mondialRelay.matchMRSelectedCountryCode()) {
    			localStorage.removeItem("storeDetailsSection");
    			localStorage.removeItem("selectedStoreData");
            }
            $shippingMethodList.load(smlUrl, function () {
                $shippingMethodList.fadeIn('fast');
                // rebind the radio buttons onclick function to a handler.
                $shippingMethodList.find('[name$="_shippingMethodID"]').click(function () {
                    var $this = $(this);

                    if ($this.hasClass('mondial-relay-method')) {
                        handleMondialRelaySelection($this);
                    } else if ($this.hasClass('royal-mail-method')) {
                        handleRoyalMailSelection($this);
                    } else if ($this.hasClass('chronopost-method')) {
                        handleChronopostSelection($this);
                    } else {
                        handleDefaultSelection();
                    }

                    selectShippingMethod($this.val());
                });
                // update the summary
                updateSummary();
                progress.hide();
                tooltip.init();

                // Initialize shipping methods on load
                initializeShippingMethodsOnLoad($shippingMethodList);
            });
            initScrollProductInformation();
        }
    });
}

/**
 * Check there is an address selected, if not, disable the continue button
 * */
function checkSelectedAddress(){
	var $form = $('form[id$="_shippingAddress"]');
	var $submit = $form.find('button[type="submit"]');
	
	// enable the submit button if there are no shipping card
	// if there are, user must have at least 1 selected shipping card for the button to be enabled
	if($form.find('.address-tile').length == 0 || $form.find('.address-tile.selected').length){
		$submit.prop('disabled', false);
	} else {
		$submit.prop('disabled', true);
	}
}

function validateAddrForm() {
    var addr = getAddressFromForm();
    return addr.address1 && addr.city && addr.postalCode && addr.countryCode;
}

function taxCalculate (e) {
		e.preventDefault();
		$(this).hide();
		$('.order-tax-calculation').removeClass('hide');
}

/*
 * This function pre-populates the calling country code in
 * mobile phone number field on shipping page.
 */
function prePopulateCallingCountryCode(countryCode) {
	if(validateAddrForm){
		var addr = getAddressFromForm();
		var phoneFiled = $('input[name$="_phone"]');
		if(addr.countryCode !== undefined){           
			if( ($('input[name$="_phone"]').length > 0) ){               
		    	var callingCountryCode = util.getCallingCountryCode(addr.countryCode);
		    	$('input[name$="_phone"]').attr('data-country-code', callingCountryCode);
		    }
		} else if(countryCode !== undefined && countryCode !== ''){
			if( ($('input[name$="_phone"]').length > 0) ){
		    	var callingCountryCode = util.getCallingCountryCode(countryCode);
		    	$('input[name$="_phone"]').attr('data-country-code', callingCountryCode);
		    }
		}
		
		util.handleCountryCodeUpdate(phoneFiled);
	}
}

function prePopulateToolTip(countryCode,currentElement) {
	if(currentElement !== undefined && currentElement !== ''){
		var $countryCode = countryCode.toLowerCase();
		var postalTooltip = currentElement.data('postalcodetooltipjson')[$countryCode];
		currentElement.closest('form').find('.postal-code .tooltip .tooltip-content').html(postalTooltip);
	}
}

// to prepolulate country code only when input[type=text] field rendered
function inputPrePopulateCallingCountryCode() {
    var $country = $('input[id$="_addressFields_country"]');
    if($country.length) {
        prePopulateCallingCountryCode($country.val());
    }
}

/*
 * Valid Postal and City
 */
function getValidPostalCity(addressId,displModal,disableBut){
    var $form = $('form[id$="_shippingAddress"]');
    var $submit = $form.find('button[type="submit"]');

    disableBut == true ? $submit.removeAttr('disabled') : '';
    $('form[id$="_shippingAddress"]').find('.shipping-error').text('');
    
    if(displModal) {
        initEditAddressModal(addressId, false);
    } else { 
        updateShippingMethodList();	 
    }
	
}


function initEditAddressModal(addressID, invalidateFields){
    var addressID = addressID;

    modal.addCustomClass('edit-add-address');
    modal.events.onOpen(function() {
        validator.initForm('form[id="EditAddressForm"]');
        
        var $form = $('form[id$="EditAddressForm"]');            	
        
        var setDefaultCheckbox = $('input[id$="_setdefault"]');
        if (setDefaultCheckbox.prop('checked')) {
            setDefaultCheckbox.attr('disabled', 'true');
        }

        $('select[id$="_country"]').val($('[name$="CountryCodeFromSavedAddress"]').val());
        tooltip.init();
        // to enable autocomplete for city and postal fields (FR locale)
        checkoutAddress.init();
        googleAddressAutocomplete.init();
        $('html').addClass('modal-open');
    });
    
    modal.setCallback(function() {           
        $('.input-text.postal').removeAttr("inputmode").removeAttr("pattern");
        var $form = $('form[id$="EditAddressForm"]');
        var $savedCountry = '';
        if($form.find('select[name$="_country"]').length > 0){
            $savedCountry = $form.find('select[name$="_country"]').val().toLowerCase();
            var postalTooltip= $('select[name$="_country"]').data('postalcodetooltipjson')[$savedCountry];
            $form.find('.postal-code .tooltip .tooltip-content').html(postalTooltip);
        } else {
            $savedCountry = $form.find('input[id$="_country"]').val().toLowerCase();
        }
        var countryCode = util.getCallingCountryCode($savedCountry);
        var phoneFiled =  $form.find('input[name$="_phone"]');
        phoneFiled.attr('data-country-code', countryCode);

        // if city and postal not valid
        if(invalidateFields) {
        	$('#EditAddressForm .postal').val('');
            $('#EditAddressForm .city').val('');
            validator.initEmptyInputValidation($('#EditAddressForm .postal'));
            validator.initEmptyInputValidation($('#EditAddressForm .city'));
        }
    });
    modal.renderByUrl(Urls.checkoutEditAddress + addressID + "&isRedesign="+$( "body" ).hasClass( "checkout_page" ));   
    inputField.setEditMaterialFields();
    modal.events.onClose(function() {
        $('html').removeClass('modal-open');
    });
}

/**
 * Validate mondial relay address on click of submit button.
 */
function validateMondialRelayAddress() {
    if($("input:radio.shipping-method-input:checked").hasClass('mondial-relay-method') && $('.store-details-section').is(':empty')) {
    	var $shippingMethodList = $('#shipping-method-list');
    	progress.show($shippingMethodList);
    	$('input:radio.shipping-method-input').each(function() {
			if(!$(this).hasClass('mondial-relay-method')) {
				$(this).trigger('click');
				return false; // break loop
			}
		});
    	progress.hide();            
    }
}

/**
 * Validate Royal Mail address on click of submit button.
 */
function validateRoyalMailAddress(thisShipping) {
    if($("input:radio.shipping-method-input:checked").hasClass('royal-mail-method') && thisShipping.parent().find('.store-details-royalMail-section .address-line1').is(':empty')) {
    	var $shippingMethodList = $('#shipping-method-list');
    	progress.show($shippingMethodList);
    	$('input:radio.shipping-method-input').each(function() {
			if(!$(this).hasClass('royal-mail-method')) {
				$(this).trigger('click');
				return false; // break loop
			}
		});
    	progress.hide();            
    }
}


function savedAddressViewShipping () {
	var savedAddressShipping = $('.saved-addresses.select-shipping-address .address-tile');
    $(document).find('.select-shipping-address div.address-list div.address-tile').each(function() {
        if($('.select-shipping-address div.address-default.selected').length <=0) {
            if($(this).hasClass('address-default')) {
                $(this).addClass('selected');
            }
        }
    });

	// Keep this control idempotent when checkout init runs more than once.
	$('.shipping-address-show-more').remove();
	$('.checkout_page').off('click.shippingShowMore', '.shipping-address-show-more');

	if (savedAddressShipping.length > 3) {
        $('.billing-address-section').before("<div class='shipping-address-show-more'>" + Resources.SEE_MORE_CARDS + "</div>");

        $('.checkout_page').on('click.shippingShowMore', '.shipping-address-show-more', function () {
            const $seeMore = $(this);
            if ($seeMore.text() !== Resources.SEE_LESS_CARDS) {
                $seeMore.text(Resources.SEE_LESS_CARDS);
                $seeMore.addClass('is-show');
                $('.shipping-address-section .select-shipping-address').addClass('see-more-clicked');
                //stickySidebar.destroy();
            } else {
                $seeMore.text(Resources.SEE_MORE_CARDS);
                $seeMore.removeClass('is-show');
                $('.shipping-address-section .select-shipping-address').removeClass('see-more-clicked');
            }

            savedAddressShipping.toggle();
          //This code may be required in future once billing sections are implemented
		  /*setTimeout(() => {
			var primaryBillingLength = $('#primary .billing').length;
			var reinsuranceCheckoutMobileLength = $('.reinsurance-checkout-mobile').length;
			if ($(window).width() > 991 && $('.checkout_page').length) {
				var stickySidebarNew = new StickySidebar('#secondary .right-side-checkout', {
					resizeSensor: true,
					topSpacing:  primaryBillingLength > 0 && reinsuranceCheckoutMobileLength === 0 ? -116 : primaryBillingLength > 0 && reinsuranceCheckoutMobileLength > 0 ? 11 : 116,
					bottomSpacing: reinsuranceCheckoutMobileLength ? -132 : 80,
					innerWrapperSelector: '.sidebar__inner'
				});
			}
		  }, 2000);*/
        });
      }
}

function getShippingPhoneNumWithCode() {
	if($('#dwfrm_singleshipping_shippingAddress_addressFields_phoneNumber').length === 0) { 
		return; 
	}
	$(document).on('focusout','input[class~="phonenumber"]', function() {
		var customFoneNumber = $('#dwfrm_singleshipping_shippingAddress_addressFields_phoneNumber').val();
		var selectedCountryCode = $('#dwfrm_singleshipping_shippingAddress_addressFields_country').val();
		var custFoneNumb = util.getFormattedPhoneNumber(customFoneNumber,selectedCountryCode);
		$('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val(custFoneNumb);		
	});
}
function editPhoneNumberWithCode() {
	if($('#dwfrm_shippingaddress__emea_phoneNumber').length === 0) { 
		return; 
	}
	$(document).on('focusout','input[class~="phonenumber"]', function() {
		var customFoneNumber = $('#dwfrm_shippingaddress__emea_phoneNumber').val();
		var selectedCountryCode = $('#dwfrm_shippingaddress__emea_phoneNumber').val();
		var custFoneNumb = util.getFormattedPhoneNumber(customFoneNumber,selectedCountryCode);
		$('#dwfrm_shippingaddress__emea_phone').val(custFoneNumb);		
	});
}

function billingSectionErrorMessage () {
	$(window).on('load', function () {
		if(!$('.sameasbilling').is(':checked') && $('.select-billing-address .error-placement').length > 1) {
			$('.select-billing-address').find('.error-placement').parent().find('input').blur();
		}
	})
}

function validateAddAdressError() {
	var $addPopup = $('.reveal.edit-add-address.new-add-address'),
		$popupForm = $addPopup.length && $addPopup.closest('form[id$="EditAddressForm"]'),
		$invalidMethodError = $addPopup.find('.this-is-invalid'),
		$invalidFormError = $popupForm.find("div.error-placement");

	if ($invalidMethodError.length && $invalidFormError.length) {
		$shippingForm.find('button[name$="_address_create"]').attr('disabled', 'disabled');
	} else if($invalidMethodError.length && $invalidFormError.length === 0) {
		$shippingForm.find('button[name$="_address_create"]').attr('disabled', 'disabled');		
	} else {
		$shippingForm.find('button[name$="_address_create"]').removeAttr('disabled');
	}
}

// display accordion on mobile devices for product information
function initMobileProductInformation() {
    $(document).on("mouseenter",".order-shipping .icon-question", function(){
        tooltip.init();
    });
    
    $(document).on('click', '.checkout-articles', function(e) {
        e.stopImmediatePropagation();
        $(".checkout-articles .down-arrow, .checkout-articles .up-arrow").toggleClass("hide");
        $(".checkout-mini-cart").toggleClass("hide");
    });
}

// custom scroll for product information
function initScrollProductInformation() {
    let isTablet = window.matchMedia("(max-width: 768px)").matches;
    if (!isTablet) {
        $(".mini-cart-product-container").scrollBox();
    }
}

$(window).on('load', function() {
    tooltip.init();
    var isTablet = window.matchMedia("(max-width: 768px)").matches;
    if (!isTablet) {
        initScrollProductInformation();
    }
});

function checkoutReinsurancePopup() {
	$(document).on('click', 'a.cart-reinsuance-modal', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $this = $(this);
        analytics.reinsuranceElements($this.attr('id'));		
        
        $.ajax({
			url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
            method: 'GET'
        })
        .done(function (response) { 
            if(response) {
                modal.addCustomClass('checkout-reinsurance-inner-wrapper');
                modal.renderContent(response);
            }
        });
	});
}

/**
 * @function
 * @description Intercepts coupon apply button click on shipping page,
 * submits via AJAX with format=ajax (mirrors cart's promoCodeBehaviour pattern),
 * then swaps in the fresh coupon block and refreshes the summary.
 */
function initCouponBehaviour() {

    // Ensure live region exists
    if ($('#coupon-live-region').length === 0) {
        $('body').append('<div id="coupon-live-region" aria-live="polite" role="status" class="visually-hidden"></div>');
    }

    // Enable or disable coupon form button
    function enableDisableButtonBasedOnCoupon() {
        const $btn = $('#add-coupon');
        if ($('input[name$="couponCode"]').val() == "") {
            $btn.prop('disabled', true);
        } else {
            $btn.prop('disabled', false);
        }
    }

    $('input[name$="_cart_couponCode"]').on('keyup', function () {
        enableDisableButtonBasedOnCoupon();
        hideCouponError();
    });

    $('input[name$="_cart_couponCode"]').on('paste cut', function () {
        setTimeout(() => {
            enableDisableButtonBasedOnCoupon();
        }, 500);
    });

    function hideCouponError() {
        $('body').on('keyup change', '.order-totals-table .cart-coupon-code input', function () {
            const error_msg = $('.cart-coupon-code').find('.error');
            if (error_msg.length) {
                $(error_msg)
                    .hide()
                    .removeAttr('role aria-live'); // clean up accessibility attrs

                $('#coupon-live-region').text('');
            }
        });
    }

    $('body')
        .off('click', 'button[name$="addCoupon"], button[name$="deleteCoupon"]')
        .on('click', 'button[name$="addCoupon"], button[name$="deleteCoupon"]', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const $button = $(this);
            const $form = $button.closest('form');
            const actionType = $button.attr('name').includes('deleteCoupon') ? 'removed' : 'applied';
            const couponCodeText = $button.closest('.coupon-container').find('.cartcoupon').attr('data-name');
			const messageApplied = $('.coupon-wrapper').attr('data-message-applied');
			const messageRemoved = $('.coupon-wrapper').attr('data-message-removed');
			const $liveRegionContainer = $('#coupon-live-region');

            // Announce action immediately to screen readers before AJAX call
			// Avoid announcing an undefined coupon code — fall back to the generic message.
			let actionAnnouncement = '';
			if (couponCodeText) {
				actionAnnouncement = actionType === 'removed' && `${couponCodeText} ${messageRemoved}`;
			} else {
				actionAnnouncement = actionType === 'removed' ? messageRemoved : '';
			}
			$liveRegionContainer.text(actionAnnouncement);

            const postData =
                $form.serialize() +
                '&' +
                $button.attr('name') +
                '=' +
                ($button.val() || $button.attr('name')) +
                '&format=ajax';

            progress.show($form);

            $.ajax({
                type: 'POST',
                url: Urls.addPromoOnShipping,
                data: postData,
                success: function (response) {
                    const $newCouponBlock = $(response).find('.cart-coupon-code');

                    if ($newCouponBlock.length) {
                        $('.cart-coupon-code').replaceWith($newCouponBlock);

						const couponCode = $newCouponBlock.find('.cartcoupon').last().attr('data-name');

						// Announce action for applied coupon, avoid 'undefined'
						let finalAnnouncement = '';
						if (couponCode) {
							finalAnnouncement = actionType === 'applied' ? `${couponCode} ${messageApplied}` : '';
						}

						$liveRegionContainer.text(finalAnnouncement);

                        // Handle error messages (if present)
                        const $error = $newCouponBlock.find('.error');
                        if ($error.length) {
                            $error
                                .attr('role', 'alert')
                                .attr('aria-live', 'assertive');

                            $('#coupon-live-region').text($error.text().trim());
                        }
                    }

                    updateSummary();
                    progress.hide();
                },
                error: function () {
                    progress.hide();

                    // Announce failure clearly
                    $('#coupon-live-region').text('Error applying coupon. Please try again.');
                },
                complete: function () {
                    // Announce update
                    setTimeout(() => {
                        if (actionType === 'applied') {
                            $('.cart-coupon-code').find('.remove-coupon-button').focus();
                        } else {
                            $('.cart-coupon-code').find('input[name$="couponCode"]').focus();
                        }
                    }, 2000);

                }
            });
        })
        .off('keydown.cartCoupon', '.cart-coupon-code input')
        .on('keydown.cartCoupon', '.cart-coupon-code input', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                $('#add-coupon').trigger('click');
            }
        });
}

export default {
    init: function () {
        initEvents();
        tooltip.init();
        checkoutReinsurancePopup();
        initCouponBehaviour();
        if (window.User.isCustomerAuthenticated == false) {
            $('.checkout-shipping').find('.setdefault').closest('.form-row').hide();
        }

	validator.initForm('form[name$="shippingAddress_save"]');
    $('.address1').attr('autocomplete', 'on'); // Avoid to autocomplete address 1

    giftMessageBox();
    updateShippingMethodList();
    initMobileProductInformation();

    $(document).find('.select-shipping-address div.address-list div.address-tile').each(function() {
        if ($(this).hasClass('default') || $(this).hasClass('selected') || $(this).hasClass('address-default')) {
            $(this).removeClass('selected');
            $(this).removeClass('default');
        }
    });

    checkSelectedAddress();
    $(document).on('click', '.tax-estimate-link', taxCalculate);  
    
    $(document).on('change','select[id$="_addressFields_country"], select[id$="__emea_country"]', function() {  	
    	var countryCode = $(this).val();
    	var currentElement = $(this);
        if (countryCode) {
            prePopulateCallingCountryCode(countryCode);
    	    prePopulateToolTip(countryCode,currentElement);
        }
    });

	singleShippingDesign();
    savedAddressViewShipping();

    $('.sameasbilling').on('change', function () {
        $('.billing-address-section').parent().find('input').blur();
    });

    inputPrePopulateCallingCountryCode();   
    
    checkoutAddress.init();
    googleAddressAutocomplete.init();
    util.characterLimitEvents();
    getShippingPhoneNumWithCode();
    editPhoneNumberWithCode();
    billingRedesign.init();
    billingSectionErrorMessage();
    initScrollProductInformation();
    initCache();
    cart.cartPayPalExpressPopup();
    //apple pay error display
    $(document).on('applePayDisplayErr', function (event, json, string) {
        // parameter is stocked in json.data here.
        cart.postAppleErr(json.dataErr);
    });
    
    //nationality
    $(document).on('applePayDisplayNationality', function (event, json, string) {
        // parameter is stocked in json.data here.
        cart.getApplePayDisplayNationality('applepay');
    });
    
    //consent pop-up
    $(document).on('applePayDisplayConsent', function (event, json, string) {
        // parameter is stocked in json.data here.
        cart.getApplePayConsentModal();
    });
    },
    updateShippingMethodList: updateShippingMethodList
};